import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

import { useAuth } from 'features/auth';
import { EventsProps } from '../types';

const useGA = (trackingIds: string[]) => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  const { studentUuid } = useAuth();

  const gaEventTrack = useCallback(
    (props: EventsProps) => {
      if (initialized) {
        ReactGA.event(
          props,
          trackingIds.map((_, gaIndex) => `tracker${gaIndex}`)
        );
      }
    },
    [initialized, trackingIds]
  );

  const gaPageviewTrack = useCallback(
    (path: string) => {
      ReactGA.pageview(
        path,
        trackingIds.map((_, gaIndex) => `tracker${gaIndex}`)
      );
    },
    [initialized, trackingIds]
  );

  useEffect(() => {
    if (trackingIds.length) {
      ReactGA.initialize(
        trackingIds.map((trackingId, gaIndex) => ({ trackingId, gaOptions: { name: `tracker${gaIndex}` } })),
        { debug: false, alwaysSendToDefaultTracker: false }
      );

      setInitialized(true);
    }
  }, [trackingIds]);

  useEffect(() => {
    if (initialized) {
      gaPageviewTrack(location.pathname + location.search);
    }
  }, [initialized, location, trackingIds]);

  useEffect(() => {
    if (initialized && studentUuid) {
      ReactGA.set(
        { userId: studentUuid },
        trackingIds.map((_, gaIndex) => `tracker${gaIndex}`)
      );
    }
  }, [studentUuid, trackingIds]);

  return initialized ? { gaEventTrack, gaPageviewTrack } : null;
};

export default useGA;
